import { CommonModule } from '@angular/common';
import { Component, DestroyRef, ElementRef, Inject, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppContentEntity } from '@nk/data-entities-lib';
import { ButtonDirective, SpinnerComponent } from '@nk/ui-lib';
import { APP_CONTENT_API_SERVICE_TOKEN, AppContentApiService } from '@nk/api-lib';
import { SignUpService } from '../../../../services/sign-up.service';

@Component({
  selector: 'nk-sign-up-tos',
  imports: [CommonModule, TranslateModule, SpinnerComponent, ReactiveFormsModule, ButtonDirective],
  templateUrl: './sign-up-tos-privacy.component.html',
})
export class SignUpTosPrivacyComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public showErrors = false;
  public earlierStepError = false;
  @ViewChild('earlierStepError') public elemRef: ElementRef;
  public termsOfService: AppContentEntity;
  public privacyPolicy: AppContentEntity;
  public loadingSuccess = false;
  private _destroy = inject(DestroyRef);

  constructor(
    private _signUpService: SignUpService,
    @Inject(APP_CONTENT_API_SERVICE_TOKEN)
    private _contentService: AppContentApiService,
  ) {}

  public ngOnInit(): void {
    this.earlierStepError = false;
    this.formGroup = this._signUpService.formContractAgreement;
    this._signUpService.getShowError().subscribe((showError) => {
      this.showErrors = showError;
    });

    this._contentService
      .fetchAppContentByIdentifier('terms-of-service')
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe((payload) => {
        this.termsOfService = payload;
        this.formGroup.patchValue({ tos_content_hash_uuid: payload.content_hash_uuid });
      });

    this._contentService
      .fetchAppContentByIdentifier('privacy-policy')
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe((payload) => {
        this.privacyPolicy = payload;
        this.formGroup.patchValue({ privacy_content_hash_uuid: payload.content_hash_uuid });
      });
  }

  public onNext(): void {
    this.loadingSuccess = true;
    if (!this._signUpService.formContractAgreement.valid) {
      this._signUpService.setShowError(true);
    } else if (this._signUpService.formCustomer.valid && this._signUpService.formUser.valid) {
      this._signUpService.completeSignup();
    } else {
      this.earlierStepError = true;
      // what to do? this should not happen. Go back to start?
    }
  }
}
